var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix text-center"},[_c('h4',{staticClass:"pt-3"},[_vm._v(_vm._s(_vm.aLang.SurveyResultSuccessful_success_message))])])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }